import i18n from 'utils/i18n';
import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object().shape({
    api_token: Yup.string().required(i18n.t('errors.required')),
  });
